import { use } from "react";

import { UserContext } from "@/contexts";

const useOutboundQueryParams = (campaign: string = "freetrial") => {
  const { user: userData } = use(UserContext);

  const paramsToInclude = {
    email: userData?.email,
    phone: userData?.phoneNumber,
    company: userData?.company?.name,
    secteur_d_activites: userData?.company?.industry?.marketingSegment?.code,
    public_id: userData?.company?.public_id,
    utm_source: "produit",
    utm_medium: "in-app",
    utm_campaign: campaign,
  };

  let params = "";

  for (const [key, value] of Object.entries(paramsToInclude)) {
    if (value) {
      if (params.length > 0) {
        params += `&${key}=${encodeURIComponent(value)}`;
      } else {
        params = `?${key}=${encodeURIComponent(value)}`;
      }
    }
  }

  return params;
};

export default useOutboundQueryParams;
